<template>
  <div>
    <div class="showlabel">
      <h4>选择题库</h4>
      <div class="testtype">组件模式：{{ groupmode }}</div>
      <div class="testtype">命题方式：{{ unified }}</div>
      <div class="testtype" @click="newandto">添加范围</div>
    </div>
    <!-- 原生写法s -->
    <el-card>
      <el-form :v-model="appCptArr">
        <table style="width: 100%">
          <tr class="table_title">
            <td></td>
            <td>出题范围</td>
            <td>可设置题数</td>
            <td>抽题数</td>
            <td>分值(分)</td>
            <td>分值比例（%）</td>
            <td style="width: 200px">操作</td>
          </tr>
          <template v-for="(item, index) in appCptArr">
            <tr
              v-for="(zitem, zindex) in styleAllArr[index].children"
              :key="index + '' + zindex"
              :class="{
                blue:
                  (index % 2 === 0 && zindex % 2 === 1) ||
                  (index % 2 === 1 && zindex % 2 === 0),
              }"
            >
              <td
                v-if="zindex === 0"
                :rowspan="styleAllArr[index].children.length"
                class="Colorless"
              >
                <div class="operation_text">
                  <p ref="slots">范围{{ numberChinese(index + 1) }}</p>
                  <!-- <p>{{ (1 / appCptArr.length).toFixed(2) * 100 }}%</p> -->
                  <p>{{ testcopesum(styleAllArr[index].children) }}%</p>
                </div>
              </td>
              <td
                v-if="zindex === 0"
                :rowspan="styleAllArr[index].children.length"
                class="Colorless"
              >
                <div class="scope_box">
                  <p class="scope_text" :class="{ blue: index % 2 === 1 }">
                    {{ item[0].AppName }}
                  </p>
                  <div class="overflow_box">
                    {{ item[0].cptArr | cptArrCont }}
                    <!-- <template v-for="(resitem, residnex) in item[0].cptArr">
                      <span
                        :key="residnex + '' + index + '' + zindex"
                        class="scope_text"
                        :class="{
                          blue:
                            (index % 2 === 0 && residnex % 2 === 0) ||
                            (index % 2 === 1 && residnex % 2 === 1),
                        }"
                      >
                        {{ resitem.ChapterName }}
                      </span>
                    </template> -->
                    <!-- <p>一共十个章节</p> -->
                  </div>
                </div>
              </td>
              <td>
                <div class="floating">
                  <p>{{ zitem.Total }}</p>
                  <p>{{ "(" + zitem.StyleName + ")" }}</p>
                </div>
              </td>
              <td class="td_input">
                <el-input
                  v-model="zitem.input"
                  @input="fn(zitem.input, zitem,index,zindex)"
                ></el-input>
              </td>
              <td>
                {{ zitem.sumAdd ? zitem.sumAdd + "分" : "" }}
              </td>
              <td>
                {{
                  zitem.sumAdd
                    ? ((zitem.sumAdd / isSumAdd) * 100).toFixed(2) + "%"
                    : ""
                }}
              </td>
              <td
                v-if="zindex === 0"
                :rowspan="styleAllArr[index].children.length"
                class="operation_btn Colorless"
              >
                <div>
                  <el-button type="text" size="small" @click="renewandto(index)"
                    >修改当前范围</el-button
                  >
                  <el-button type="text" size="small" @click="deletes(index)"
                    >删除</el-button
                  >
                </div>
              </td>
            </tr>
          </template>
          <tr class="combined">
            <td>合计</td>
            <td></td>
            <td></td>
            <td>{{ sumAdd }}题</td>
            <td>{{ isSumAdd }}分</td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </el-form>
      <div class="operation">
        <el-button class="succ_btn" @click="beforeStep">上一步</el-button>
        <el-button type="success" class="submit_btn" @click="nextStep"
          >下一步</el-button
        >
      </div>
      <!-- 提示小弹窗 -->
      <div class="delete_view">
        <el-dialog title="温馨提示" :visible.sync="lncompleteHint">
          <p>题量必须是0或者是正整数</p>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="lncompleteHint = false"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
      <!-- 为空的时候拦截弹窗 -->
      <!-- 题型超出提示弹窗 -->
      <div class="topic_num">
        <el-dialog
          title="温馨提示"
          :visible.sync="emptyPopup"
          :close-on-click-modal="false"
        >
          <p>权重范围不能为空</p>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="emptyPopup = false"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
      <div class="topic_num">
        <el-dialog
          title="温馨提示"
          :visible.sync="topicNumPopup"
          :close-on-click-modal="false"
        >
          <p>题量大于该题型"{{ topicData }}"的总题量：{{ topicNum }}</p>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="topicNumPopup = false"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getPaperStyle } from "@/api/weight.js";
import loginvuex from "@/store/index";
export default {
  name: "weightRange",
  data() {
    return {
      lncompleteHint: false, // 判断不为数字小弹窗
      topicNumPopup: false, // 判断题目数量超出小弹窗
      emptyPopup: false, //为空的弹窗拦截
      groupmode: "", //组卷模式
      unified: "", //统一命题
      isnowselecttestcopenum: 0, //当前选择的范围的唯一ID
      firstperform: true, //** 备用数据  代表编辑进来第一次加载这个组件 true是第一次进来， false代表不是
      isaddnewscope: 1, //** 备用数据 默认为1 新增一个范围
      //是否需要新增范围，在activated里面进行判断0不新增不修改，1新增范围，2修改不新增范围
      styleAllArr: [
        // {
        //   name: 0,
        //   children: [
        //     // { StyleName: "A题型", Total: 12, Score: 1 },
        //     // { StyleName: "B题型", Total: 10, Score: 2 },
        //     // { StyleName: "C题型", Total: 5, Score: 1 },
        //   ],
        // },
        // {
        //   name: "第二次请求",
        //   children: [
        //     { StyleName: "A题型", Total: 12, Score: 1 },
        //     { StyleName: "B题型", Total: 10, Score: 1 },
        //     { StyleName: "C题型", Total: 5, Score: 1 },
        //     { StyleName: "C题型", Total: 5, Score: 1 },
        //   ],
        // },
        // {
        //   name: "第三次请求",
        //   children: [
        //     { StyleName: "A题型", Total: 12, Score: 1 },
        //     { StyleName: "B题型", Total: 10, Score: 1 },
        //     { StyleName: "C题型", Total: 5, Score: 1 },
        //     { StyleName: "C题型", Total: 5, Score: 1 },
        //   ],
        // },
      ],
      appCptArr: [
        // [
        // 这里是一次请求的范围
        // {
        //   AppName: "医师分册试题集",
        //   AppEName: "SJSTJ_YSFCDEB",
        //   cptArr: [
        //     { ChapterName: "1.1.6 药理学试卷" },
        //     { ChapterName: "1.1.6 药理学试卷" },
        //   ],
        // },
        // {
        //   AppName: "师生分册试题集",
        //   AppEName: "SJSTJ_YSFCDEB",
        //   cptArr: [
        //     { ChapterName: "1.1.6 人体学试卷" },
        //     { ChapterName: "1.1.7 生物学学试卷" },
        //     { ChapterName: "1.1.6 药理学试卷" },
        //   ],
        // }
        // ]
      ],
      sumAdd: 0, //计算题数
      isSumAdd: 0, // 计算分数
      topicData: "", // 题型
      topicNum: "", // 题数
      styelArr: [], //传递给第四步数据渲染
      DroitName: "", //范围的索引
      DroitSum: "", //
      textArr: [],
    };
  },
  props: ["cutcoms"],
  filters: {
    cptArrCont(e) {
      let cont = "";
      e.forEach((item) => {
        cont += item.ChapterName + "\n";
      });
      return cont;
    },
  },
  methods: {
    deletes(index) {
      if (this.$parent.paperinfomation != undefined) {
        this.$confirm("此操作将永久删除该范围, 是否继续?", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.styleAllArr.splice(index, 1);
          this.appCptArr.splice(index, 1);
        });
        return;
      }
      this.$confirm("此操作将永久删除该范围, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let obj = {};
          this.appCptArr[index].map((item) => {
            obj[item.AppEName] = item.cptArr.map((items) => {
              return items.ExamCptID;
            });
            return obj;
          });
          let newbj = this.$parent.$children[1].selectChapter;
          for (let key in newbj) {
            if (obj[key]) {
              newbj[key] = newbj[key].filter((item) => {
                return obj[key].indexOf(item) == "-1";
              });
            }
          }
          this.$parent.$children[1].selectChapter = newbj;
          this.appCptArr.splice(index, 1);
          this.styleAllArr.splice(index, 1);
          if (!this.appCptArr.length) {
            this.newandto();
          }
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    fn(row, item,index,zindex) {
      console.log(row,'W1kao',item,this.styleAllArr[index].children[zindex]);
      console.log(this.styleAllArr,'666');
      // 2024/4/15 产品新增输入0删除当前项
      if(row == 0){
        if(this.styleAllArr[index].children.length > 1){
        this.styleAllArr[index].children.splice(zindex,1)
        }else{
          this.deletes(index)
          // this.styleAllArr.splice(index,1)
          // this.styleAllArr = []
        }
      }
      //this.lncompleteHint=true;
      Number(row);
      if (!isNaN(row)) {
        // this.lncompleteHint = false;
      } else {
        // this.lncompleteHint = true;
        this.$message({
          message: "必须成正数",
          type: "success",
        });
      }
      this.topicData = item.StyleName;
      this.topicNum = item.Total;
      if (row > item.Total) {
        //题数超过拦截
        this.topicNumPopup = true;
        item.input = "";
      }
      this.addCombined(); // 执行计算题数拿到input的值
      this.styleAllArr.forEach((item, i) => {
        item.children.forEach((sub) => {
          sub.TestCount = JSON.parse(JSON.stringify(sub.input));
          sub.sumAdd = sub.input * sub.Score === 0 ? "" : sub.input * sub.Score;
        }); // 单个题的分值
      });
      this.addScore(); // 执行计算分数
    },
    createstyleArr() {
      // 选中题型的数据传递   造style数据
      let style = [];
      this.styleAllArr.map((item) => {
        item.children.map((zitem) => {
          if (zitem.input !== "") {
            style.push(zitem);
          }
        });
      });
      let repeatarr = {}; //造好全部选择的数据
      style.map((item) => {
        if (repeatarr[item.StyleName] === undefined) {
          repeatarr[item.StyleName] = [];
          repeatarr[item.StyleName].push(item);
        } else {
          repeatarr[item.StyleName].push(item);
        }
      });
      let linrepeatarr = JSON.parse(JSON.stringify(repeatarr));
      for (let key in linrepeatarr) {
        if (linrepeatarr[key].length > 1) {
          linrepeatarr[key] = linrepeatarr[key].reduce((first, scend) => {
            first.TestCount = Number(first.TestCount) + Number(scend.TestCount);
            first.Total += Number(scend.Total);
            first.ExamStyleID = this.uq(first.ExamStyleID, scend.ExamStyleID);
            return first;
          });
        } else {
          linrepeatarr[key] = linrepeatarr[key][0];
        }
      }
      for (let key in linrepeatarr) {
        this.styelArr.push(linrepeatarr[key]);
      }
    },
    pagethressrefn() {
      //权重的第四步需要重新计算一次总分，这个方法只在第四页调用。
      this.addCombined(); // 执行计算题数拿到input的值
      this.styleAllArr.forEach((item, i) => {
        item.children.forEach((sub) => {
          sub.sumAdd = sub.input * sub.Score === 0 ? "" : sub.input * sub.Score;
        }); // 单个题的分值
      });
      this.addScore(); // 执行计算分数
      this.styelArr[0]["weightreducefen"] = this.isSumAdd; //分   下面那个是题
      this.styelArr[0]["weightreducesum"] = this.sumAdd; //藏在发送的第0位的里面
      this.$parent.pageStyelArr = this.styelArr;
      this.fns();
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 合并单元格
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 4,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 6) {
        if (rowIndex === 0) {
          return {
            rowspan: 4,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },

    totoal(c, a, b) {
      // 移入移出计算分值
      this.afterinput[a].splice(b, 0, this.input[a][b] * c.Score);
    },
    // 计算题数
    addCombined() {
      // var sum = this.styleAllArr[0].
      let sum = [];
      this.styleAllArr.forEach((item, i) => {
        sum[i] = item.children.reduce(function (prev, cur) {
          if (isNaN(cur.input)) {
            cur.input = "";
          }
          return Number(cur.input) + prev;
        }, 0);
        return sum;
      });
      this.sumAdd = sum.reduce((x, y) => x + y); //总提数
    },
    // 计算分数
    addScore() {
      let isSum = [];
      this.styleAllArr.forEach((item, i) => {
        isSum[i] = item.children.reduce(function (prev, cur) {
          if (isNaN(cur.sumAdd)) {
            cur.sumAdd = "";
          }
          return Number(cur.sumAdd) + prev;
        }, 0);
        return isSum;
      });
      this.isSumAdd = isSum.reduce((x, y) => x + y);
    },
    // 汉字范围一
    numberChinese(number) {
      const strNumber = number.toString();
      const len = strNumber.length;
      let numberCh = "";
      for (let i = 0; i < len; i++) {
        let currentNum = strNumber.substr(i, 1);
        switch (currentNum) {
          case "0":
            numberCh += "零";
            break;
          case "1":
            numberCh += "一";
            break;
          case "2":
            numberCh += "二";
            break;
          case "3":
            numberCh += "三";
            break;
          case "4":
            numberCh += "四";
            break;
          case "5":
            numberCh += "五";
            break;
          case "6":
            numberCh += "六";
            break;
          case "7":
            numberCh += "七";
            break;
          case "8":
            numberCh += "八";
            break;
          case "9":
            numberCh += "九";
            break;
          default:
            numberCh += "*";
        }
      }
      return numberCh;
    },
    newasddsocpe() {
      let stlylename = this.styleAllArr.length;
      let newtestcopeobj = {};
      newtestcopeobj.name = stlylename; //定义一个id唯一标识符
      newtestcopeobj.children = [];
      this.styleAllArr.push(newtestcopeobj); //第一次执行直接添加新的数据。
      this.isnowselecttestcopenum = stlylename; //当前索引。
    },
    async getDataList() {
      let params = {
        config: JSON.stringify(this.$parent.pagetwodata), // 科目章节
        hid: JSON.parse(loginvuex.state.userlist).hid,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        FilterHour: 0,
      };
      if (this.$parent.paperinfomation) {
        //编辑的是回选。
        params.config = JSON.stringify(
          this.$parent.random_Proportion_data.SelectcharpterCpt
        );
      }
      const Data = await getPaperStyle(params);
      if (Data.data.Status === 200) {
        if (this.isaddnewscope == 1) {
          //新增情况下新增
          this.newasddsocpe();
          Data.data.Data.styleAllArr = Data.data.Data.styleAllArr.map(
            (item) => {
              item.input = "";
              item.sumAdd = "";
              return item;
            }
          );
          this.styleAllArr[this.isnowselecttestcopenum].children =
            Data.data.Data.styleAllArr;
          this.styleAllArr[this.isnowselecttestcopenum].cpt = JSON.parse(
            params.config
          );
          this.appCptArr.push(Data.data.Data.appCptArr);
        } else if (this.isaddnewscope == 2) {
          //修改情况下的新增
          //这里写修改一个范围的时候
          this.sumAdd = 0;
          this.isSumAdd = 0;
          Data.data.Data.styleAllArr.map((item) => {
            item.input = "";
            item.sumAdd = "";
            return item;
          });
          this.styleAllArr[this.isnowselecttestcopenum].children =
            Data.data.Data.styleAllArr;
          this.styleAllArr[this.isnowselecttestcopenum].cpt =
            this.$parent.pagetwodata;
          this.appCptArr.splice(
            this.isnowselecttestcopenum,
            1,
            Data.data.Data.appCptArr
          );
        }
      } else {
        this.$message.error("数据获取不到");
      }
    },
    renewandto(index) {
      //修改范围
      this.isaddnewscope = 2; //修改的时候 状态调为2
      this.isnowselecttestcopenum = index;
      let isableoptions = JSON.parse(JSON.stringify(this.appCptArr)); //禁用数据
      let isselectdata = isableoptions.splice(index, 1);
      let isselectobj = {}; //回传给第二页选中的数据 选中的。
      isselectdata[0].map((item) => {
        isselectobj[item.AppEName] = item.cptArr.map((zitem) => {
          return zitem.ExamCptID;
        });
      });
      //以下是禁用的数据
      isableoptions = isableoptions.flat(2);
      let isableobj = {}; 
      isableoptions.map((item) => {
        if (isableobj[item.AppEName] === undefined) {
          isableobj[item.AppEName] = item.cptArr;
        } else {
          //  let linshi = item.cptArr
          isableobj[item.AppEName] = isableobj[item.AppEName].concat(
            item.cptArr
          );
        }
      });
      if (this.$parent.paperinfomation != undefined) {
        let SelectcharpterCpt = {};
        this.appCptArr.map((item) => {
          item.forEach((item) => {
            let newCptArr = item.cptArr.map((item) => {
              return item.ExamCptID;
            });
            if (!SelectcharpterCpt[item.AppEName]) {
              SelectcharpterCpt[item.AppEName] = newCptArr;
            } else {
              SelectcharpterCpt[item.AppEName] =
                SelectcharpterCpt[item.AppEName].concat(newCptArr);
            }
          });
        });
        this.$parent.random_Proportion_data.isaddnewselectChapter = JSON.parse(
          JSON.stringify(isselectobj)
        );
        this.$parent.random_Proportion_data.SelectcharpterCpt = JSON.parse(
          JSON.stringify(SelectcharpterCpt)
        );
        this.$parent.random_Proportion_data.isableoptions = JSON.parse(
          JSON.stringify(isableobj)
        );
        this.$parent.random_Proportion_data.isaddnewscope = 1;
        this.cutcoms(9);
        return;
      }
      this.$parent.$children[1].isaddnewselectChapter = isselectobj; // 回显数据
      this.$parent.$children[1].isableoptions = isableobj; // 禁用数据
      this.$parent.$children[1].isaddnewcope = 1; // 1 新增状态
      this.cutcoms(1);
    },
    newandto() {
      //新增一个范围。
      this.isaddnewscope = 1; //新增的时候 状态调为1
      //编辑模式进来 新增一个范围》
      if (this.$parent.paperinfomation != undefined) {
        this.cutcoms(9);
        let newchar = {};
        this.appCptArr.forEach((item) => {
          item.forEach((item) => {
            let newCptArr = item.cptArr.map((item) => {
              return item.ExamCptID;
            });
            if (!newchar[item.AppEName]) {
              newchar[item.AppEName] = newCptArr;
            } else {
              newchar[item.AppEName] = newchar[item.AppEName].concat(newCptArr);
            }
          });
        });
        this.$parent.random_Proportion_data.SelectcharpterCpt = JSON.parse(
          JSON.stringify(newchar)
        );
        this.$parent.random_Proportion_data.isableoptions = JSON.parse(
          JSON.stringify(newchar)
        );
        this.$parent.random_Proportion_data.isaddnewscope = 1;
        return;
      }
      setTimeout(() => {
        //延迟，不然拿不到全部的this.appCptArr
        let isableoptions = this.appCptArr.flat(2);
        let isableobj = {};
        isableoptions.map((item) => {
          if (isableobj[item.AppEName] === undefined) {
            isableobj[item.AppEName] = item.cptArr;
          } else {
            //  let linshi = item.cptArr
            isableobj[item.AppEName] =isableobj[item.AppEName].concat(item.cptArr);
          }
        });
        this.$parent.$children[1].isableoptions = isableobj;
        this.$parent.$children[1].isaddnewcope = 1;
        this.cutcoms(1);
      }, 300);
    },
    nextStep() {
      this.createstyleArr();
      this.isaddnewscope = 0;
      if (this.styelArr == "" || this.styelArr.length == 0) {
        this.emptyPopup = true;
      } else {
        this.styelArr[0]["weightreducefen"] = this.isSumAdd;
        this.styelArr[0]["weightreducesum"] = this.sumAdd; //藏在发送的第0位的里面
        if (this.$parent.paperinfomation != undefined) {
          this.$parent.israndom_Proportion = "1";
          this.$parent.random_Proportion_data.pageStyelArr = this.styelArr;
          this.$parent.random_Proportion_data.qzHTML = this.appCptArr;
          this.fns();
          this.cutcoms(2);
          return;
        }
        this.$parent.pageStyelArr = this.styelArr;
        this.$parent.qzHTML = this.appCptArr;
        this.fns();
        this.cutcoms(2);
        // 这里将选中的数据传递给第四步
      }
    },
    beforeStep() {
      //返回上一步的判断。
      if (this.$parent.paperinfomation) {
        this.firstperform = true;
        this.cutcoms(0);
      } else {
        this.renewandto(this.styleAllArr.length - 1);
      }
    },
    fns() {
      let sub_data = [];
      this.styleAllArr.forEach((c, i) => {
        let sub_obj = {};
        let bus_index = i + 1;
        let text_arr = [];
        c.children.forEach((v, j) => {
          let text_obj = {
            type: v.Type,
            style: v.StyleName,
            count: v.TestCount,
            total: v.Total,
            score: v.Score,
            explain: v.Explain,
            ExamStyleID: v.ExamStyleID,
          };
          if (v.input !== "") {
            text_arr.push(text_obj);
          }
        });
        sub_obj.qzName = `范围${this.numberChinese(bus_index)}`;
        sub_obj.cpt = c.cpt; //这个地方死的
        sub_obj.test = JSON.parse(JSON.stringify(text_arr));
        sub_data.push(sub_obj);
      });
      let DroitSum_new = [];
      this.styleAllArr[0].children.forEach((sv, si) => {
        let obj_new = Object.assign({}, sv);
        obj_new.qzName = `范围${sv}`;
        DroitSum_new.push(obj_new);
      });
      let DroitArr = {};
      DroitArr["0"] = sub_data;
      if (this.$parent.paperinfomation != undefined) {
        this.$parent.random_Proportion_data.DroitArr = DroitArr;
        return;
      }
      this.$parent.DroitArr = DroitArr;
    },
    //对比两个数组，去除重复的部分，返回一个新的数组
    uq(array, array1) {
      let setObj = new Set(array);
      for (let i = 0; i < array1.length; i++) {
        setObj.add(array1[i]);
      }
      //使用Array.from()方法将set对象转换成数组，并使用sort()方法进行排序
      return Array.from(setObj);
    },
    //编辑模式下权重的数据在这里进行转换。
    getpeperconfig() {
      //只有在编辑第一次进来的时候取一下数据。
      this.isSumAdd = JSON.parse(
        this.$parent.paperinfomation[1].Config
      ).DroitArr["1"].Score;
      this.sumAdd = JSON.parse(this.$parent.paperinfomation[1].Config).DroitArr[
        "1"
      ].Total;
      this.styleAllArr = JSON.parse(
        this.$parent.paperinfomation[1].Config
      ).DroitArr["0"].map((item, index) => {
        let newobj = {};
        newobj.name = index;
        newobj.cpt = item.cpt;
        newobj.children = item.test.map((items) => {
          let newchildrenobj = {};
          newchildrenobj.ExamStyleID = items.ExamStyleID;
          newchildrenobj.StyleName = items.style;
          newchildrenobj.Explain = items.explain;
          newchildrenobj.TestCount = items.count;
          newchildrenobj.Type = items.type;
          newchildrenobj.input = items.count;
          newchildrenobj.sumAdd = items.score * items.count;
          newchildrenobj.Total = items.total;
          newchildrenobj.Score = items.score;
          return newchildrenobj;
        });
        return newobj;
      });
      let configdata = JSON.parse(
        this.$parent.paperinfomation[1].Config
      ).qzHTML;
      if (configdata.indexOf("div") == "-1" && configdata != "") {
        this.appCptArr = JSON.parse(
          this.$parent.paperinfomation[1].Config
        ).qzHTML;
      } else {
        this.appCptArr = JSON.parse(
          this.$parent.paperinfomation[1].Config
        ).DroitArr["0"].map((item, index) => {
          let newarr = [];
          let newobj = {};
          //   newobj['AppName'] = item.qzName
          for (let key in item.cpt) {
            newobj["AppEName"] = key;
            newobj["cptArr"] = item.cpt[key];
            newarr.push(newobj);
          }
          return newarr;
        });
      }
    },
  },
  computed: {
    testcopesum() {
      return function (sum) {
        let res = sum.reduce((first, scend) => {
          if (typeof first == "string" || typeof first == "number") {
            return Number(first) + scend.sumAdd;
          } else {
            return first.sumAdd + scend.sumAdd;
          }
        });
        if (sum.length == 1) {
          res = sum[0].sumAdd;
        }
        if (res == "" || res == "0") {
          return 0;
        }
        let d = (res / this.isSumAdd).toFixed(3);
        d = parseFloat(d);
        d = d * 100;
        d = d.toFixed(1);
        return d;
      };
    },
  },
  created() {
    if (this.$parent.paperinfomation) {
      this.getpeperconfig();
      if (this.$parent.paperinfomation[0].PaperMode == "random_Proportion") {
        this.groupmode = "权重组卷";
        this.unified = "随机命题";
      } else {
        this.groupmode = "权重组卷";
        this.unified = "统一命题";
      }
      return;
    }
    this.groupmode = this.$parent.testmode;
    this.unified = this.$parent.checkmode;
    this.firstperform = false;
  },
  activated() {
    //会先执行create，再执行
    if (this.$parent.paperinfomation && this.firstperform) {
      this.firstperform = false;
      return;
    }
    if (this.firstperform) {
      this.styleAllArr = [];
      this.appCptArr = [];
      this.firstperform = false;
    }
    this.styelArr = [];
    this.getDataList();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  padding: 0;
}
::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
::v-deep .el-range-separator {
  color: #eeeeee !important;
}
::v-deep .el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #afd9ff;
  border-right: 1px solid #afd9ff;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
}
::v-deep.el-table .cell {
  text-align: center !important;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 100px 0 70px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
// 原生
table,
tr,
td {
  border: 1px solid #afd9ff;
  border-collapse: collapse; //不加上这个会重合边框
  tr {
    td {
      height: 60px;
      text-align: center;
      color: #999999;
    }
  }
}
.table_title {
  width: 100%;
  background: #8fcbff;
  border-radius: 10px 10px 0px 0px;
  font-size: 15px;
  font-family: PingFang SC;

  font-weight: bold;
  > td {
    border: none !important;
    color: #333333;
  }
}
.trrow {
  background: #f5faff;
  > :nth-child(1) {
    background: rgb(255, 255, 255);
  }
  :nth-last-child(1) {
    background: rgb(255, 255, 255);
  }
}
::v-deep .el-button--text {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #1890ff;
}
.operation_btn {
  > div {
    display: flex;
    flex-direction: column;
    p:nth-child(1) {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
    }
    p:nth-child(2) {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
}
.operation_text {
  p:nth-child(1) {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
  }
  p:nth-child(2) {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    margin-top: 10px;
  }
}
.el-input {
  width: 180px;
  height: 60px;
}
.td_input {
  width: 200px;
  > .el-input {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
  ::v-deep .el-input__inner {
    text-align: center;
  }
}
.scope_text {
  height: 60px;
  //   border: 1px solid red;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.overflow_box {
  white-space: pre-line;
  line-height: 63px;
  background: linear-gradient(#f5faff 50%, #fff 50%);
  background-size: 100% 126px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.blue {
  background: #f5faff;
}
.Colorless {
  background: rgb(255, 255, 255) !important;
  color: #333333;
}
.floating {
  display: flex;
  height: 20px;
  justify-content: center;
  align-items: center;
  color: #999999;
  > p:nth-child(1) {
    margin-right: 12px;
    transform: translateY(2px);
  }
}
.scope_box {
  color: #999999;
}
.combined {
  // display: flex;
  background: #f5faff;
  height: 70px;
  text-align: center;
  border: none !important;
  > tr,
  td {
    border: none !important;
  }
  > td {
    color: #333333;
    font-size: 18px;
    font-weight: bold;
  }
}
// 弹窗
.delete_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
  }

  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }

  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .el-dialog {
    width: 350px;
    height: 200px;
    border-radius: 5px 5px 0px 0px;
    align-items: center;
    .input_layout {
      display: flex;
    }
  }
  ::v-deep .el-dialog__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.topic_num {
  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .el-dialog {
    width: 350px;
    height: 200px;
    border-radius: 5px 5px 0px 0px;
    align-items: center;
    .input_layout {
      display: flex;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.showlabel {
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    //background-color: antiquewhite;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 50px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
}
</style>
